export const baseUrl = process.env.REACT_APP_API_URL
export const imageUrl = process.env.REACT_APP_API_IMAGE_URL

